import { Card, Typography, Tabs, Divider } from "antd";
import { useNavigate } from "react-router-dom";
import TabPane from "antd/es/tabs/TabPane";
import Holidays from "../../../Components/Holidays";
import TimeSlot from "../../../Components/TimeSlot";
import { LeftOutlined } from "@ant-design/icons";
import { useState } from "react";
const TimeslotsHolidays = () => {
  const navigate = useNavigate();
  const [zoneName] = useState(localStorage.getItem("zoneName"));
  const [defaultIndex, setDefaultIndex] = useState("1");

  const onTabChange = (key) => {
    setDefaultIndex(key);
  };

  return (
    <>
      <Card>
        <div className="flex justify-between mb-4 gap-5">
          <div className="">
            <Typography className="text-xl font-semibold" align={"left"}>
              <LeftOutlined
                className="mr-2"
                onClick={() => navigate("/manage-zones")}
              />
              {/*  please do dynamic zone name  */}
              {zoneName} - Timeslots & Holidays
            </Typography>
          </div>
        </div>
        <Divider />
        <div className="w-full overflow-auto">
          <Tabs
            tabPosition="left"
            activeKey={defaultIndex}
            onChange={onTabChange}
          >
            <TabPane tab="Time Slots" key="1">
              {defaultIndex === "1" && <TimeSlot />}
            </TabPane>
            <TabPane tab="Holidays" key="2">
              {defaultIndex === "2" && <Holidays />}
            </TabPane>
          </Tabs>
        </div>
      </Card>
    </>
  );
};
export default TimeslotsHolidays;
